import { ActivatedRoute, Router } from '@angular/router';
import { ModalController, Platform } from '@ionic/angular';
import { PrescricaoService } from '../../../services/prescricao.service';
import { PrescricaoQrcodeComponent } from '../../modal-components/prescricao-qrcode/prescricao-qrcode.component';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-prescricoes-detalhe-component',
  templateUrl: './prescricoes-detalhe-component.html',
  styleUrls: ['./prescricoes-detalhe-component.scss'],
})
export class PrescricoesDetalheComponent implements OnInit {

  isMobile = false;
  detalhePrescricao: any = [];

  @Input() id: number;
  @Output() medClicked = new EventEmitter();
  @Output() prescricaoVoltar = new EventEmitter();

  constructor(
    private active: ActivatedRoute,
    public router: Router,
    private plt: Platform,
    private modalController: ModalController,
    private prescricaoService: PrescricaoService
  ) {
    if (this.plt.is('ios') || this.plt.is('android') || this.plt.is('cordova')) {
      this.isMobile = true;
    }
  }

  async ngOnInit() {


    this.detalhePrescricao = await this.prescricaoService.get(this.id);
    console.log('==========detalhePrescricao', this.detalhePrescricao);

  }

  async detalhar(med) {
    this.medClicked.emit(med);
  }

  async voltar() {
    this.prescricaoVoltar.emit();
  }

  async exportar(id) {
  }

  async qrCode(id) {
    const modal = await this.modalController.create({
      component: PrescricaoQrcodeComponent,
      keyboardClose: true,
      cssClass: 'modal-bottom-default',
      backdropDismiss: true,
      showBackdrop: true,
      componentProps: {
        id
      }
    });

    return await modal.present();
  }
}
